import {
  AppBase,
  baseFromDoc,
  FirestoreBaseDoc,
  makeDocConverter,
} from '../base/firestore-model-base'

export type ManualItemDoc = {
  title: string
  detail: string
}

export type ManualItem = {
  title: string
  detail: string
}

/**
 * config/manual ドキュメント
 *
 * - `ManualConfigDoc`: Firestore に保存される形
 * - `ManualConfig`: アプリで扱う形
 */
export type ManualConfigDoc = FirestoreBaseDoc & {
  manuals: ManualItemDoc[]
}

export type ManualConfig = AppBase & {
  manuals: ManualItem[]
}

export const manualConfigDocConverter = makeDocConverter<ManualConfigDoc>()

function toManualItem(doc: ManualItemDoc): ManualItem {
  return {
    title: doc.title ?? '',
    detail: doc.detail ?? '',
  }
}

export function toManualConfig(id: string, doc: ManualConfigDoc, path: string): ManualConfig {
  const base = baseFromDoc(id, doc, path)
  return {
    ...base,
    manuals: (doc.manuals ?? []).map(toManualItem),
  }
}
